import { useCallback, useEffect, useState } from 'react'
import { api } from '@/lib/api'
import type { ApiHealth } from '@/lib/api'
import { ApiError } from '@/lib/api/client'
import { Link } from 'react-router-dom'

type HealthState =
  | { kind: 'loading' }
  | { kind: 'ok'; data: ApiHealth }
  | { kind: 'error'; message: string }

export function HomePage() {
  const [health, setHealth] = useState<HealthState>({ kind: 'loading' })

  const load = useCallback(async () => {
    setHealth({ kind: 'loading' })
    try {
      const data = await api.health()
      setHealth({ kind: 'ok', data })
    } catch (err) {
      const message = err instanceof ApiError ? `${err.status} ${err.code}: ${err.message}` : String(err)
      setHealth({ kind: 'error', message })
    }
  }, [])

  useEffect(() => {
    void load()
  }, [load])

  return (
    <main>
      <h1>Puzzle Platform</h1>
      <p className="muted">Configurable browser-based puzzle and treasure-hunt events.</p>
      <p>
        Players enter through an event link such as <Link to="/play/demo-event">/play/demo-event</Link>.
      </p>

      <section className="card" aria-live="polite">
        <h2>Backend status</h2>
        {health.kind === 'loading' && <p>Checking…</p>}
        {health.kind === 'error' && (
          <p className="status-err" role="alert">
            Backend unreachable: {health.message}
          </p>
        )}
        {health.kind === 'ok' && (
          <dl>
            <dt>Status</dt>
            <dd className="status-ok">{health.data.status}</dd>
            <dt>Service</dt>
            <dd>{health.data.service}</dd>
            <dt>Version</dt>
            <dd>{health.data.version}</dd>
            <dt>Environment</dt>
            <dd>{health.data.environment}</dd>
            <dt>Checked at</dt>
            <dd>{new Date(health.data.timestamp).toLocaleTimeString()}</dd>
          </dl>
        )}
        <p>
          <button type="button" onClick={() => void load()} disabled={health.kind === 'loading'}>
            Refresh
          </button>
        </p>
      </section>
    </main>
  )
}
